import React, { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export default function OfflineIndicator() {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    return () => {
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
    };
  }, []);
  if (online) return null;
  return (
    <div data-testid="offline-indicator" className="fixed top-0 left-0 right-0 z-50 bg-blue-500 text-white py-1 text-center text-xs uppercase tracking-widest font-bold flex items-center justify-center gap-2" style={{ paddingTop: "calc(0.25rem + env(safe-area-inset-top))" }}>
      <WifiOff className="w-3 h-3" /> Offline · Reading from cache
    </div>
  );
}
